import WindowMessenger from '@robotsnacks/window-messenger';

export const getMessenger = () => {
  return new WindowMessenger({
    allowedOrigins: /.*/,
    // TODO: better!
    target: () =>
      document.getElementsByTagName('iframe')[0].contentWindow as any,
  });
};
